import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

// Ein einfacher nackter Button, die Styles kommen (wie gewohnt) vom BaseWidget
const StyledButton = styled.a`
  display: inline-block;
  cursor: pointer;
  text-decoration: none;
`;

export function Button({ node, isLiveMode }) {
  const content = node.content || {};
  const text = content.text || 'Klick mich';
  const url = content.url || '#';

  return (
    <StyledButton href={isLiveMode ? url : '#'} onClick={e => !isLiveMode && e.preventDefault()}>
      {text}
    </StyledButton>
  );
}

registry.register('Button', {
  label: 'Button',
  icon: '🎯',
  category: 'basic',
  component: Button,
  defaultProps: {
    content: {
      text: 'Jetzt sichern',
      url: '#'
    },
    style: {
      desktop: {
        backgroundColor: '#00A9E0',
        color: '#ffffff',
        padding: '12px 24px',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '600',
        textAlign: 'center',
        display: 'inline-block'
      }
    }
  },
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Link & Text',
          fields: [
            { name: 'content.text', type: 'text', label: 'Button Text' },
            { name: 'content.url', type: 'text', label: 'Verlinkung (URL)' }
          ]
        }
      ]
    },
    {
      tab: 'style',
      groups: [
        {
          title: 'Design',
          fields: [
            { name: 'style.desktop.backgroundColor', type: 'color', label: 'Hintergrund' },
            { name: 'style.desktop.color', type: 'color', label: 'Textfarbe' },
            { name: 'style.desktop.borderRadius', type: 'text', label: 'Rundung (Radius)' }
          ]
        },
        {
          title: 'Abmessungen',
          fields: [
            { name: 'style.desktop.padding', type: 'text', label: 'Innenabstand' },
            { name: 'style.desktop.width', type: 'text', label: 'Feste Breite (opt.)' }
          ]
        }
      ]
    }
  ]
});
